<template>
  <div class="page">
    <el-input v-model="title" placeholder="文章标题" class="titinput"></el-input>
    <el-upload :action="uploadUrl" :headers="headers" class="upload-demo" :on-preview="handlePreview"
      :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
      :file-list="fileList" :on-success="filesuccess">
      <el-button size="small" type="primary">点击上传</el-button>
      <!-- <input type="text" :value="token"> -->
      <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
    </el-upload>
    <div class="submit" @click="submit">确认提交</div>

  </div>
</template>
<!-- <script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.0.js"></script> -->
<script>
export default {
  name: 'upload',
  data() {
    return {
      fileList: [],
      innertoken: "",
      uploadUrl: 'https://try.api.yiliku.huayao-ai.com/yimai/aiDoc/file/upload',
      headers: {
        token: "",
      },
      title: "",
      fileId: "",
    }
  },
  created() {
    document.title = "华肤荟";
    console.log(this.$route.query.token)
    this.innertoken = this.$route.query.token
    // alert(this.innertoken)
    this.headers.token = this.innertoken
  },
  methods: {
    // backtoapp(){
    //   wx.miniProgram.navigateBack({})
    // },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    customUpload() {
      const formData = new FormData();
      formData.append('file', this.fileList); // 添加文件到FormData中

      // 配置headers，例如添加token或者任何自定义header
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data', // 根据实际情况调整，通常不需要手动设置Content-Type，因为FormData会自动设置
          'token': '' // 示例：添加认证token
        },
      };

      // 使用axios发送请求
      this.$axios.post('YOUR_API_ENDPOINT', formData, config)
        .then(res => {
        })
        .catch(error => {
        });
    },
    filesuccess(res, file, fileList) {
      // console.log(res)
      // this.title = res.content.origFileName
      this.fileId = res.content.id
      this.time = res.content.createTime
    },
    submit() {
      let that = this
      this.$axios.post('/api/api/web/YiMaiClient/AddPersonDucoment', {
        title: this.title,
        fileId: this.fileId,
        datePublish: this.time
      }, {
        headers: {
          "token": that.innertoken,
        }
      }).then(res => {
        this.$message({
          message: '上传成功！请点击返回按钮返回小程序',
          type: 'success'
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: .5rem 5%;
  box-sizing: border-box;
}

.titinput {
  margin-bottom: .5rem;
}

.submit {
  width: 80%;
  margin: auto;
  height: 35px;
  line-height: 35px;
  border-radius: 35px;
  background-color: rgb(64, 158, 255);
  color: #ffffff;
  text-align: center;
  margin-top: .5rem;
}
</style>